import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../redux/actions';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import _ from 'lodash';
import moment from 'moment';
import { Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { REPAIR_STATUS } from 'config/constant/RepairStatus';
import { SUB_CATEGORY_REPAIR } from 'config/constant/SubCategoryRepair';
import { HeadAndTailVehiclePrintPDF } from '../../report/HeadAndTailVehiclePrintPDF';
import { HeadVehiclePrintPDF } from '../../report/HeadVehiclePrintPDF';
import { TailVehiclePrintPDF } from '../../report/TailVehiclePrintPDF';
import RepairStatusBadge from '../../../../components/Badge/RepairStatusBadge';
import currencyFormatterTH from 'util/functions/currencyFormat';

export default function RepairVehicleLists({
    repair,
    company,
    setIsSelectedRepairData,
    handleModalOn,
    handleRecordModalOn,
    sub_vehicle,
    size,
    page,
}) {
    const dispatch = useDispatch();

    const changeStatus = (id, status) => {
        const payload = {
            repair_status: status,
        };
        dispatch(actions.repairPut(id, payload)).then(() => {
            alert('สำเร็จ');
            dispatch(actions.repairAllVehicle({ size: size, page: page }));
        });
    };

    const postLog = (data) => {
        console.log('data', data);
        data.repair_status = REPAIR_STATUS[3];

        dispatch(actions.repairPut(data.repair_id, data)).then(() => {
            dispatch(actions.repairLogPost(data)).then(() => {
                alert('สำเร็จ');
                dispatch(actions.repairAllVehicle({ size: size, page: page }));
            });
        });
    };

    const showStatus = (status) => {
        if (status === REPAIR_STATUS[0]) {
            return (
                <div className="text-xs text-center px-1  bg-blue-100 hover:bg-blue-200 rounded whitespace-nowrap">
                    {status}{' '}
                </div>
            );
        } else if (status === REPAIR_STATUS[1]) {
            return (
                <div className="text-xs text-center px-2 bg-green-100 hover:bg-green-200 rounded  whitespace-nowrap">
                    {status}
                </div>
            );
        } else if (status === REPAIR_STATUS[2]) {
            return (
                <div className="text-xs text-center px-2 bg-Indigo-100 hover:bg-green-200 rounded  whitespace-nowrap">
                    {status}
                </div>
            );
        } else {
            return (
                <div className="text-xs text-center px-2 bg-red-100 hover:bg-green-200 rounded  whitespace-nowrap">
                    {status}
                </div>
            );
        }
    };

    const genTd = () => {
        return _.map(repair, (_repair, index) => (
            <Tr key={_repair.repair_id}>
                <Td>
                    <div className="text-center">
                        {(page - 1) * size + index + 1}
                    </div>
                </Td>
                <Td>
                    <div className="text-center">
                        {moment(_repair?.createdAt).format('L')}
                    </div>
                </Td>
                <Td>
                    <div className="text-center">
                        {_repair?.employee?.employee_first_name +
                            ' ' +
                            _repair?.employee?.employee_last_name}
                    </div>
                </Td>
                <Td>
                    <div className="text-center">
                        {_repair?.typeData?.detail}
                    </div>
                </Td>
                <Td>
                    <div className="text-center">
                        {_repair?.driver?.employee_first_name +
                            ' ' +
                            _repair?.driver?.employee_last_name}
                    </div>
                </Td>
                <Td>
                    {_repair?.vehicle == null ? (
                        <div className="text-center"> - </div>
                    ) : (
                        <div className="text-center">
                            {_repair?.vehicle?.category_vehicle?.category_name +
                                '/' +
                                _repair?.vehicle?.sub_category_vehicle
                                    ?.sub_category_name}
                        </div>
                    )}
                </Td>
                <Td>
                    {_repair?.vehicle == null ? (
                        <div className="text-center"> - </div>
                    ) : (
                        <div className="text-center">
                            {_repair?.vehicle?.serial_number}
                        </div>
                    )}
                </Td>
                <Td>
                    {_repair?.mileage == null ? (
                        <div className="text-center"> - </div>
                    ) : (
                        <div className="text-center">
                            {currencyFormatterTH.format(
                                _repair?.mileage?.mileage
                            )}
                        </div>
                    )}
                </Td>
                <Td>
                    <div className="flex justify-center">
                        <Button
                            size="xs"
                            onClick={() => {
                                if (sub_vehicle === SUB_CATEGORY_REPAIR[0]) {
                                    HeadVehiclePrintPDF(_repair, company);
                                } else if (
                                    sub_vehicle === SUB_CATEGORY_REPAIR[1]
                                ) {
                                    TailVehiclePrintPDF(_repair, company);
                                } else if (
                                    sub_vehicle === SUB_CATEGORY_REPAIR[2]
                                ) {
                                    HeadAndTailVehiclePrintPDF(
                                        _repair,
                                        company
                                    );
                                }
                            }}
                        >
                            <i className="fas fa-print cursor-pointer mr-1"></i>{' '}
                            พิมพ์
                        </Button>
                    </div>
                    <div
                        className="text-center"
                        onClick={() => {
                            setIsSelectedRepairData(_repair);
                            handleModalOn();
                        }}
                    >
                        <span className="text-xs text-blue-500 hover:text-blue-700 cursor-pointer text-center">
                            รายละเอียด
                        </span>
                    </div>
                </Td>
                <Td>{showStatus(_repair?.repair_status)}</Td>
                <Td>
                    {
                        <div className="flex justify-center">
                            <div>
                                <Button
                                    colorScheme="yellow"
                                    size="sm"
                                    onClick={() => {
                                        setIsSelectedRepairData(_repair);
                                        handleModalOn();
                                    }}
                                    disabled={
                                        _repair?.repair_status ===
                                        REPAIR_STATUS[1]
                                    }
                                >
                                    <div className="text-white">พิจารณา</div>
                                </Button>
                            </div>
                            <div className="px-2">
                                <Button
                                    colorScheme="blue"
                                    size="sm"
                                    onClick={() => {
                                        changeStatus(
                                            _repair.repair_id,
                                            REPAIR_STATUS[1]
                                        );
                                    }}
                                    disabled={
                                        _repair?.repair_status ===
                                        REPAIR_STATUS[1]
                                    }
                                >
                                    อนุมัติ
                                </Button>
                            </div>
                            <div className="">
                                <Button
                                    colorScheme="green"
                                    size="sm"
                                    onClick={() => {
                                        setIsSelectedRepairData(_repair);
                                        handleRecordModalOn();
                                    }}
                                >
                                    บันทึกการซ่อม
                                </Button>
                            </div>
                            <div className="px-2">
                                <Button
                                    colorScheme="red"
                                    size="sm"
                                    onClick={() => {
                                        const confirm = window.confirm(
                                            'ยืนยันการลบข้อมูลการแจ้งซ่อม'
                                        );
                                        if (confirm) {
                                            postLog(_repair);
                                        }
                                    }}
                                >
                                    ยกเลิก
                                </Button>
                            </div>
                        </div>
                    }
                </Td>
            </Tr>
        ));
    };

    return (
        <div className="flex-auto">
            <Table className="bg-white" size="sm">
                <colgroup>
                    <col width="5%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="5%" />
                    <col width="15%" />
                </colgroup>
                <Thead>
                    <Tr>
                        <Th>
                            <div className="text-center">ลำดับ</div>
                        </Th>
                        <Th>
                            <div className="text-center">วันที่แจ้งซ่อม</div>
                        </Th>
                        <Th>
                            <div className="text-center">ผู้แจ้ง</div>
                        </Th>
                        <Th>
                            <div className="text-center">ประเภทการแจ้งซ่อม</div>
                        </Th>
                        <Th>
                            <div className="text-center">พนักงานขับรถ</div>
                        </Th>

                        <Th>
                            <div className="text-center">ประเภทรถ</div>
                        </Th>

                        <Th>
                            <div className="text-center">ทะเบียนรถ</div>
                        </Th>
                        <Th>
                            <div className="text-center">เลขไมล์</div>
                        </Th>

                        <Th>
                            <div className="text-center">ใบแจ้งซ่อมรถ</div>
                        </Th>
                        <Th>
                            <div className="text-center">สถานะ</div>
                        </Th>
                        <Th>
                            <div className="text-center">ดำเนินการ</div>
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>{genTd()}</Tbody>
            </Table>
        </div>
    );
}
